// @ts-strict-ignore
import React from 'react';
import { useState } from 'react';
import { ButtonReact } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { UserFlag } from 'common/report/constants';
import { setUserFlag } from 'common/report/queries/app-api/user-flags';
import FirstStepImage from 'common/assets/images/starter-board/starterboard-modal-step1.webp';
import SecondStepImage from 'common/assets/images/starter-board/starterboard-modal-step2.webp';
import ThirdStepImage from 'common/assets/images/starter-board/starterboard-modal-step3.webp';
import styles from './index.module.styl';
enum ModalStep {
  First = "1",
  Second = "2",
  Third = "3",
}
const titlePerStep = {
  [ModalStep.First]: "Your Starter Board is activated",
  [ModalStep.Second]: "Boards are customizable",
  [ModalStep.Third]: "Explore more templates"
};
const bodyTextPerStep = {
  [ModalStep.First]: "Great work! This board is now displaying your events and a summary of user behaviors.",
  [ModalStep.Second]: "It\u2019s easy to add, remove or update reports in Mixpanel boards.",
  [ModalStep.Third]: "Mixpanel offers a full array of ready-to-use boards."
};
export const StarterBoardActivatedModal = _ref => {
  let {
    dismiss
  } = _ref;
  const [modalStep, setModalStep] = useState<ModalStep>(ModalStep.First);
  const closeModal = (): void => {
    setUserFlag(UserFlag.DismissedStarterBoardModal);
    dismiss();
  };
  const handleClickBack = (): void => {
    modalStep === ModalStep.Second ? setModalStep(ModalStep.First) : setModalStep(ModalStep.Second);
  };
  const handleClickNext = (): void => {
    modalStep === ModalStep.First ? setModalStep(ModalStep.Second) : modalStep === ModalStep.Second ? setModalStep(ModalStep.Third) : closeModal();
  };
  return <div className={styles.starterBoardModalContainer} data-sentry-component="StarterBoardActivatedModal" data-sentry-source-file="index.tsx">
      <ButtonReact className={styles.closeButton} theme={ButtonTheme.Tertiary} icon={"x"} onClick={closeModal} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx" />
      <div className={styles.title}>{titlePerStep[modalStep]}</div>
      <div className={styles.imageContainer}>
        <img className={styles.image} src={modalStep === ModalStep.First ? FirstStepImage : modalStep === ModalStep.Second ? SecondStepImage : ThirdStepImage} />
      </div>
      <div className={styles.bodyText}>
        {bodyTextPerStep[modalStep]}
        {modalStep === ModalStep.Third && <>
            {" "}
            <a className={styles.linkToTemplate} href='/project/?show-template-selector=true'>
              Browse our templates
            </a>
          </>}
        .
      </div>
      <div className={styles.footer}>
        {modalStep === ModalStep.First ? <div className={styles.placeholder} /> : <ButtonReact styleOverride={"a.mp-button-container {width: 70px}"} theme={ButtonTheme.Secondary} onClick={handleClickBack}>
            Back
          </ButtonReact>}
        <div className={styles.pagination}>
          {Object.keys(ModalStep).map(enumKey => {
          return <ButtonReact key={enumKey} styleOverride={"a.mp-button-container {width: 41px}"} theme={ButtonTheme.Tertiary} pressed={modalStep === ModalStep[enumKey]} onClick={() => setModalStep(ModalStep[enumKey])}>
                {ModalStep[enumKey]}
              </ButtonReact>;
        })}
        </div>
        <ButtonReact styleOverride={"a.mp-button-container {width: 70px}"} theme={ButtonTheme.Primary} onClick={handleClickNext} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
          {modalStep === ModalStep.Third ? "Finish" : "Next"}
        </ButtonReact>
      </div>
    </div>;
};